module.exports = __webpack_public_path__ + "45086222a08d7ced094ee826d125eb96.jpg";